/**
 * Created by pzf on 18/9/1.
 *
 */
import lang from 'lodash/lang';
import { deepClone } from '../_util/clone';
import iconMapping from './iconMapping';

/** *******************Select************************** */
/**
 * 把外面传进来的数据解除引用关联
 * @param dataSource
 * @returns {T[]}
 */
export function getDataSource(props) {
  return deepClone(props.data);
}

export function getIconName(iconCode){
  return iconMapping[iconCode] ? `fee-${iconMapping[iconCode]}` : `fee-${iconCode}`;
}